import {
  faSort,
  faSortDown,
  faSortUp
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Fragment, useMemo } from 'react';
import { Table } from 'react-bootstrap';
import { useSortBy, useTable } from 'react-table';
import { useStores } from '../stores/useStores';

const TrapsTable = (props) => {
  const { traplogStore } = useStores();
  const data = useMemo(() => props.data, [props.data]);

  const columns = useMemo(
    () => [
      {
        Header: 'Production Site',
        accessor: (originalRow) => {
          let area = originalRow.area;
          const isHighRisk = traplogStore.isTrappingZoneHighRisk(
            originalRow.trappingZone
          );
          const isHighPressure = traplogStore.isTrappingZoneHighPressure(
            originalRow.trappingZone
          );
          return (
            <>
              <p className='float-left d-inline mr-2'>{area}</p>
              {isHighRisk ? (
                <b className='float-left' style={{ fontSize: '12px' }}>
                  (High Risk)
                </b>
              ) : null}
              {isHighPressure ? (
                <b className='float-right' style={{ fontSize: '12px' }}>
                  (High Pressure)
                </b>
              ) : null}
            </>
          );
        }
      },
      {
        Header: 'Trap ID',
        accessor: 'code'
      },
      {
        Header: 'Name',
        accessor: 'name'
      },
      {
        Header: 'Location',
        accessor: 'location_description'
      },
      {
        Header: 'Setup Date',
        accessor: (originalRow) =>
          moment(originalRow.setup_at).format('DD/MM/YYYY')
      },
      {
        Header: 'Comments',
        accessor: 'comments'
      },
      {
        disableSortBy: true,
        Header: '',
        accessor: 'edit'
      },
      {
        disableSortBy: true,
        Header: '',
        accessor: 'delete'
      }
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    useTable(
      {
        columns,
        data
      },
      useSortBy
    );

  return traplogStore.traps ? (
    <Fragment>
      <Table striped responsive size='sm' {...getTableProps()}>
        {/* This style prevent table header appearing above Select options. */}
        <thead style={{ position: 'sticky', zIndex: 0 }}>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => {
                return (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render('Header')}
                    {column.canSort ? (
                      <span className='px-2'>
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <FontAwesomeIcon icon={faSortDown} />
                          ) : (
                            <FontAwesomeIcon icon={faSortUp} />
                          )
                        ) : (
                          <FontAwesomeIcon icon={faSort} />
                        )}
                      </span>
                    ) : (
                      ''
                    )}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Fragment>
  ) : (
    <></>
  );
};

TrapsTable.propTypes = {
  data: PropTypes.array.isRequired
};

export default observer(TrapsTable);
